const GoogleMap = ()=>{
    return(
        <section id = "anu_offset_printers" className="anu_offset_printers container mt-8 mx-auto">
            <iframe
                title="Google Map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31207.87016400839!2d76.65464576499635!3d12.113262850791687!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3baf682bfe1f29eb%3A0xd1e5927b3c8e5f8!2sNanjangud%2C%20Karnataka!5e0!3m2!1sen!2sin!4v1749781371846!5m2!1sen!2sin" 
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
            />
        </section>
    )
}

export default GoogleMap